/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Ad_Render_Tts_Aria_LabelInputs */

const en_event_ad_render_tts_aria_label = /** @type {(inputs: Event_Ad_Render_Tts_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Render text-to-speech audio`)
};

const fr_event_ad_render_tts_aria_label = /** @type {(inputs: Event_Ad_Render_Tts_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generer un audio de synthese vocale`)
};

const de_event_ad_render_tts_aria_label = /** @type {(inputs: Event_Ad_Render_Tts_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text-zu-Sprache-Audio rendern`)
};

const it_event_ad_render_tts_aria_label = /** @type {(inputs: Event_Ad_Render_Tts_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trasforma l'audio in testo vocale`)
};

const ru_event_ad_render_tts_aria_label = /** @type {(inputs: Event_Ad_Render_Tts_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Воспроизведение аудио с помощью преобразования текста в речь`)
};

const es_event_ad_render_tts_aria_label = /** @type {(inputs: Event_Ad_Render_Tts_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Renderizar audio de texto a voz`)
};

const zh_cn2_event_ad_render_tts_aria_label = /** @type {(inputs: Event_Ad_Render_Tts_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将文本转换为语音`)
};

const ja_event_ad_render_tts_aria_label = /** @type {(inputs: Event_Ad_Render_Tts_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テキスト読み上げオーディオをレンダリングする`)
};

const hi_event_ad_render_tts_aria_label = /** @type {(inputs: Event_Ad_Render_Tts_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टेक्स्ट-टू-स्पीच ऑडियो प्रस्तुत करें`)
};

const pt_pt2_event_ad_render_tts_aria_label = /** @type {(inputs: Event_Ad_Render_Tts_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Renderizar áudio de texto para fala`)
};

/**
* | output |
* | --- |
* | "Render text-to-speech audio" |
*
* @param {Event_Ad_Render_Tts_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_ad_render_tts_aria_label = /** @type {((inputs?: Event_Ad_Render_Tts_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Ad_Render_Tts_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_ad_render_tts_aria_label(inputs)
	if (locale === "de") return de_event_ad_render_tts_aria_label(inputs)
	if (locale === "it") return it_event_ad_render_tts_aria_label(inputs)
	if (locale === "ru") return ru_event_ad_render_tts_aria_label(inputs)
	if (locale === "es") return es_event_ad_render_tts_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_event_ad_render_tts_aria_label(inputs)
	if (locale === "ja") return ja_event_ad_render_tts_aria_label(inputs)
	if (locale === "hi") return hi_event_ad_render_tts_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_event_ad_render_tts_aria_label(inputs)
	return en_event_ad_render_tts_aria_label(inputs)
});